<template>
  <v-container>
    <div>
      <span class="title-font-secondary text-center" v-html="t('title')"></span>
    </div>
    <v-form ref="form" @submit.prevent="">
      <v-row class="dense">
        <v-col cols="12" md="8">
          <sc-text-field
            type="select"
            :items="$store.state.designer.listPointOfSale"
            rule-required
            item-text="codename"
            item-value="id"
            v-model="pointOfSaleSelected"
            :label="t('pointSale')"
          ></sc-text-field>
        </v-col>

        <v-col cols="12" md="4" class="d-flex align-center">
          <sc-btn @click="confirmPointOfSale" block>{{
            t("enter")
          }}</sc-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    pointOfSaleSelected: null,
  }),
  computed: {
    ...mapState("designer", ["listPointOfSale"]),
  },
  mounted() {
    //Si no tiene ningun punto de venta, entra en crear
    if (this.listPointOfSale.length === 0)
      return this.$router.push(`/designer/create`);
    //Si tiene 1 punto de venta, entra directamente
    if (this.listPointOfSale.length === 1) {
      this.pointOfSaleSelected = this.listPointOfSale[0].id;
      return this.confirmPointOfSale();
    }
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`designer.home.${key}`, options);
    },
    confirmPointOfSale() {
      if (!this.$refs.form.validate()) return null;
      this.$router.push(`/designer/${this.pointOfSaleSelected}`);
    },
  },
};
</script>
